import React from 'react'
import reactDom from 'react-dom/client'
import './i18n/config'
import './styles.css'
import App from './App'

reactDom.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
